import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_MOBILE_UPDATES_REQUEST,
  FETCH_MOBILE_UPDATES_SUCCESS,
  FETCH_MOBILE_UPDATES_ERROR,
  UPDATE_MOBILE_UPDATE_REQUEST,
  UPDATE_MOBILE_UPDATE_SUCCESS,
  UPDATE_MOBILE_UPDATE_ERROR,
  REMOVE_MOBILE_UPDATE_SUCCESS,
  REMOVE_MOBILE_UPDATE_ERROR,
  GET_PAGES,
} from 'actionTypes'

const getPages = (page, size, data, dispatch) => {
  const qtt = data.length
  const qtd = size
  let pages = Math.floor(qtt / qtd)
  if (qtt % qtd > 0) {
    pages += 1
  }
  const begin = (page - 1) * qtd
  const end = page * qtd
  data = data.slice(begin, end)
  fetchMobileUpdatesSuccess(data, dispatch)

  return {
    type: GET_PAGES,
    pages,
    current: page,
    count: qtt,
  }
}


/*
 * REQUEST MOBILE_UPDATES
 */
export const fetchMobileUpdates =
  (token, page = 1, size = 10) =>
  (dispatch) => {
   
    dispatch(fetchMobileUpdatesRequest())
    dispatch(showSpinner())
    return new Api(token, dispatch)
      .get(API_URL.MOBILE_UPDATE_LIST)
      .then(async (response) => {
        
        const { data } = await new Api(token).post(API_URL.BRANCHES)
        const regionCompanies = []
        const companyOptions = []

        await Promise.all(
          data.map((company) => {
            if (regionCompanies[company.idRegion] === undefined) {
              regionCompanies[company.idRegion] = []
              regionCompanies[company.idRegion].idRegion = company.idRegion
              regionCompanies[company.idRegion].dsRegion = company.dsRegion
              regionCompanies[company.idRegion].branches = []
            }
            regionCompanies[company.idRegion].branches.push(company)
          })
        )

        regionCompanies.sort((a, b) => (a.dsRegion > b.dsRegion ? 1 : -1))

        await Promise.all(
          regionCompanies.map((region) => {
            companyOptions.push({
              value: region.idRegion,
              label: region.dsRegion,
              visible: true,
            })
            region.branches.map((branch) => {
              companyOptions.push({
                value: branch.id,
                label: `${branch.id} - ${branch.name} `,
                isBranch: true,
                idRegion: branch.idRegion,
                visible: true,
              })
              return branch
            })
            return region
          })
        )

        const allData = await Promise.all(
          [...response.data].map((data) => ({
            ...data,
            ...(data.store && {
              storeLabel: data.store.map(
                (store) =>
                  companyOptions.find((option) => option.value === store).label
              ),
            }),
            ...(data.dsLdap && {
              dsLdap:
                typeof data.dsLdap === 'object'
                  ? data.dsLdap.map((v) => v.toString())
                  : [data.dsLdap.toString()],
            }),
          }))
        )

        dispatch(getPages(page, size, allData, dispatch))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchMobileUpdatesError(error))
        dispatch(hideSpinner())
      })
  }

export const fetchMobileUpdatesRequest = () => ({
  type: FETCH_MOBILE_UPDATES_REQUEST,
})

export const fetchMobileUpdatesSuccess = (data, dispatch) => {
  if (data) {
    dispatch(mobileUpdatesSuccess(data))
  }

  dispatch(hideSpinner())
}

const mobileUpdatesSuccess = (data) => ({
  type: FETCH_MOBILE_UPDATES_SUCCESS,
  payload: data,
})

export const fetchMobileUpdatesError = (error) => ({
  type: FETCH_MOBILE_UPDATES_ERROR,
  payload: error,
})

/*
 * SAVE or UPDATE MOBILE_UPDATE
 */
export const update =
  (token, toSave = null, successModal) =>
  (dispatch) => {
    dispatch(updateMobileUpdateRequest())

    return new Api(token, dispatch)
      .post(API_URL.MOBILE_UPDATE_SAVE, toSave)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(updateMobileUpdateSuccess(response.data))
        dispatch(hideSpinner())
        successModal()
        dispatch(fetchMobileUpdates(token))
      })
      .catch((error) => {
        dispatch(updateMobileUpdateError(error))
        dispatch(hideSpinner())
      })
  }

export const updateMobileUpdateRequest = () => ({
  type: UPDATE_MOBILE_UPDATE_REQUEST,
})

export const updateMobileUpdateSuccess = (data) => ({
  type: UPDATE_MOBILE_UPDATE_SUCCESS,
  payload: data,
})

export const updateMobileUpdateError = (error) => ({
  type: UPDATE_MOBILE_UPDATE_ERROR,
  payload: error,
})

/*
 * REMOVE MOBILE_UPDATE
 */
export const remove = (token, toRemove, successModal) => (dispatch) =>
  new Api(token, dispatch)
    .post(API_URL.MOBILE_UPDATE_REMOVE, toRemove)
    .then(dispatch(showSpinner()))
    .then(() => {
      dispatch(hideSpinner())
      dispatch(removeMobileUpdateSuccess())
      dispatch(fetchMobileUpdates(token))
      successModal()
    })
    .catch((error) => {
      dispatch(removeMobileUpdateError(error))
      dispatch(hideSpinner())
    })

export const removeMobileUpdateSuccess = () => ({
  type: REMOVE_MOBILE_UPDATE_SUCCESS,
})

export const removeMobileUpdateError = (error) => ({
  type: REMOVE_MOBILE_UPDATE_ERROR,
  payload: error,
})
